import React from 'react'
import {Link} from 'react-router'
import styles from './SearchSection.scss'

export class SearchSection extends React.PureComponent {
  render () {
    return (
      <div className={styles.SearchSection}>
        <h1>Search</h1>
        <p>
          <Link to='/styleguide/search_demo'>Open Search Demo in Fullscreen &raquo;</Link>
        </p>
      </div>
    )
  }
}

export {SearchDemo} from './SearchDemo'
